import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { CommonModule } from "@angular/common";
import { IdiomaService } from "../../../services/idioma.service";
import { TraducaoService } from "../../../services/traducao.service";
import { Subscription } from "rxjs";
import { Idioma } from "../../../interfaces/idioma.interface";
import { catchError } from "rxjs";
import { of } from "rxjs";


@Component({
  selector: 'app-drop-down',
  standalone: true,
  imports: [ CommonModule ],
  templateUrl: './drop-down.component.html',
  styleUrl: './drop-down.component.css'
})

export class DropDownComponent implements OnInit, OnDestroy {
  dropdownOpen: boolean = false;
  idiomas: Idioma[] = [
    {code: 'pt-br', label: 'Português', icon: '🇧🇷'},
    {code: 'en', label: 'English', icon: '🇺🇸'},
    {code: 'es', label: 'Español', icon: '🇪🇸'}
  ]

  selectedIdioma: Idioma = {code: 'pt-br', label: 'Português', icon: '🇧🇷'};

  idiomaAtual: string = 'pt-br';
  portuguesLabel: string = '';
  inglesLabel: string = '';
  espanholLabel: string = '';

  private idiomaSubscription: Subscription = new Subscription();

  @Output() idiomaAlterado:EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private idiomaService: IdiomaService,
    private traducaoService: TraducaoService
  ) {
  }

  ngOnInit(): void {
    this.idiomaSubscription = this.idiomaService.idioma$.subscribe({
      next: (idioma) => {
        this.idiomaAtual = idioma;
        this.atualizarTraducoes();
      },
      error: (error) => {
        console.error('Erro ao alterar idioma:', error)
      }
    });
  }

  ngOnDestroy(): void {
    if (this.idiomaSubscription) {
      this.idiomaSubscription.unsubscribe();
    }
  }

  toggleDropdown(): void {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectIdioma(idioma: Idioma): void {
    this.selectedIdioma = idioma;
    this.dropdownOpen = false;

    try {
      this.idiomaService.alterarIdioma(idioma.code as 'pt-br' | 'en' | 'es')
      this.idiomaAlterado.emit(idioma.code);
      this.atualizarTraducoes();
    } catch (error) {
      console.error('Erro ao alterar idioma:', error);
    }
  }

  atualizarTraducoes(): void {
    this.traducaoService.obterTraducao('portugues').pipe(
      catchError((error) => {
        console.error('Erro ao obter tradução em Português:', error);
        return of('');
      })
    ).subscribe((traducao) => this.portuguesLabel = traducao);

    this.traducaoService.obterTraducao('ingles').pipe(
      catchError((error) => {
        console.error('Erro ao obter tradução em Inglês:', error);
        return of('');
      })
    ).subscribe((traducao) => this.inglesLabel = traducao);

    this.traducaoService.obterTraducao('espanhol').pipe(
      catchError((error) => {
        console.error('Erro ao obter tradução em Espanhol:', error);
        return of('');
      })
    ).subscribe((traducao) => this.espanholLabel = traducao);

    this.idiomas = [
      {code: 'pt-br', label: this.portuguesLabel, icon: '🇧🇷'},
      {code: 'en', label: this.inglesLabel, icon: '🇺🇸'},
      {code: 'es', label: this.espanholLabel, icon: '🇪🇸'}
    ];

    this.selectedIdioma = this.idiomas.find(i => i.code === this.idiomaAtual) || this.selectedIdioma;
  }
}
